import { render, staticRenderFns } from "./CustomerGroupCustomers.vue?vue&type=template&id=35c1aeb2&"
import script from "./CustomerGroupCustomers.vue?vue&type=script&lang=ts&"
export * from "./CustomerGroupCustomers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports